// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bQqd","content":"styles_content__2ZZ24","row":"styles_row__1Y-La","footer":"styles_footer__ciyCw","phraseLength":"styles_phraseLength__3hOGw"};